import { ResponseMESF } from "@dexteel/mesf-core";
import { Box, Paper } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import { useState } from "react";
import { CenteredLazyLoading } from "../../../../../../controls/LazyLoading";
import { AgGridFooterActions } from "../../../../../../shared/data-entries/AgGridFooterActions";
import { useDataEntryContext } from "../../../context/reducer.provider";
import { useTimerContext } from "../../../context/timer.provider";
import { useEAFDataEntryActions } from "../../../hooks/useEAFDataEntryActions";
import { useTheme } from "@mui/material/styles";
import { eafDETablesStyles } from "../styles/eafDETablesStyles";
import { useTableData } from "./hooks/useHeatingsTableData";
import { Heating } from "../../../models/eaf.models";
import { readHeatingsFromPLC } from "../../../repositories/eaf.repositories";
import { HeatingModal } from "../../modals/heating/HeatingModal";
import { defaultColDef, defaultGridOptions } from "@/setup/ag-grid/mesf-theme";

export const TableHeatings = (): JSX.Element => {
  const theme = useTheme();
  const styles = eafDETablesStyles(theme);

  const { pause, resume } = useTimerContext();

  const {
    state: { deProcess },
    actions: { setNotificationMessage, setErrorMessage },
  } = useDataEntryContext();
  const { deleteHeating, refreshData } = useEAFDataEntryActions();

  const heatings = deProcess?.heatings || [];

  const readAutomaticHeatings = async (value?: string) => {
    if (value === "OK") {
      const resp = await readHeatingsFromPLC({
        ProcessId: deProcess!.process!.ProcessId,
      });
      if (resp.ok) {
        setNotificationMessage("Read heatings from PLC successful");
        await refreshData();
        return resp as ResponseMESF;
      } else {
        setErrorMessage(resp.message);
        return {
          ok: false,
          message: "Read heatings from PLC failed",
        } as ResponseMESF;
      }
    } else {
      return {} as ResponseMESF;
    }
  };

  const { columns } = useTableData({
    deleteHeating,
  });

  return (
    <>
      <Paper>
        <Box padding={1} sx={styles.agGridBox}>
          <AgGridReact<Heating>
            rowData={heatings}
            columnDefs={columns}
            defaultColDef={{ ...defaultColDef, sortable: false }}
            loadingOverlayComponent={CenteredLazyLoading}
            {...defaultGridOptions}
          />
          <AgGridFooterActions
            hasMaxItems={true}
            readFromPLC={readAutomaticHeatings}
            table="heatings"
            pause={pause}
            resume={resume}
            show={{ new: false, plc: true }}
          />
        </Box>
      </Paper>
    </>
  );
};
